class UserDetailsService {
    constructor($http, initConfigProvider) {
        this.http = $http;
        this.apiPath = `${initConfigProvider.apiBaseUrl}${initConfigProvider.userServiceEndPoint}`;
    }
    
    getDetails(curtinId) {
        return this.http.get(`${this.apiPath}/${curtinId}`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        status: "Success",
                        data: response.data,
                        error: ''
                    };
                } else {
                    if (response.status === 400) {
                        return {
                            status: "NotFound",
                            data: null,
                            error: ''
                        };
                    } 
                }
                return {
                    status: "Error",
                    data: null,
                    error: 'User details service error'
                };
            }).catch((error) => {
                console.log(error);
                return {
                    status: "Error",
                    data: null,
                    error: 'User details service error'
                };
            });
    }
}

UserDetailsService.$inject = ['$http', 'initConfigProvider'];

export default UserDetailsService;


// WEBPACK FOOTER //
// ./app/services/user-details.service.js